// extracted by mini-css-extract-plugin
export default {"zoomControls":"zoomControls_zoomControls__GqecF"};